module.exports = __webpack_public_path__ + "img/contact-logo_m.743704f5.png";